import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@orbit/shared/auth';

interface PostLoginRouterProps {
  children?: React.ReactNode;
}

const PostLoginRouter: React.FC<PostLoginRouterProps> = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user hasn't completed onboarding, send them to onboarding
  // Treat missing onboardingCompleted as false (not completed)
  if (user?.onboardingCompleted !== true) {
    return <Navigate to="/onboarding" replace />;
  }

  return <Navigate to="/home" replace />;
};

export default PostLoginRouter;
